import axios from 'axios';
import { noteResponseLsn, withLsnHeaders, withLsnHeadersForOwnApi } from '../../src/utils/readYourWrites';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 120000,
  params: {},
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
  },
});

// 1.5.A read-your-writes. Catalog saves and imports use the global axios, so it gets it too.
axiosInstance.interceptors.request.use(withLsnHeaders);
axiosInstance.interceptors.response.use(noteResponseLsn);
axios.interceptors.request.use(withLsnHeadersForOwnApi);
axios.interceptors.response.use(noteResponseLsn);

const axiosOther = axios.create({
  timeout: 120000,
  params: {},
  headers: {
    'Content-Type': 'application/json',
  },
});

let pendingRequests = [];

const processResponse = async (fn, args, id = null) => {
  try {
    const response = await fn(...args);
    if (id) {
      pendingRequests = pendingRequests.filter((r) => r.id === id);
    }
    return {
      ...response,
      success: true,
    };
  } catch (err) {
    if (err.response) {
      return {
        data: err.response.data,
        status: err.response.status,
        success: false,
      };
    }
    return { data: err.message, success: false };
  }
};

export default {
  setToken: (token) => {
    if (token) {
      axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      delete axiosInstance.defaults.headers.common.Authorization;
    }
  },
  axiosOther,
  async get(resource, params, headers) {
    const config = { params };
    if (headers) {
      config.headers = headers;
    }
    return processResponse(axiosInstance.get, [`${BASE_URL}/${resource}`, config]);
  },
  async post(resource, body, headers, extraConfig) {
    const config = { headers, ...extraConfig };
    if (headers) {
      config.headers = headers;
    }
    return processResponse(axiosInstance.post, [`${BASE_URL}/${resource}`, body, config]);
  },
  async patch(resource, body) {
    return processResponse(axiosInstance.patch, [`${BASE_URL}/${resource}`, body]);
  },
  async put(resource, body, headers) {
    const config = { data: body };
    if (headers) {
      config.headers = headers;
    }
    return processResponse(axiosInstance.put, [`${BASE_URL}/${resource}`, body, config]);
  },
  async delete(resource, body) {
    return processResponse(axiosInstance.delete, [`${BASE_URL}/${resource}`, body]);
  },
  async upload(resource, body) {
    return processResponse(axiosInstance.post, [`${BASE_URL}/${resource}`, body, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${body._boundary}`,
      },
    }]);
  },
};

export async function submitMessageFeedback(
  messageId,
  sessionId,
  botId,
  comment,
  expectedResponse,
  reporterMetadata = {}
) {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/feedback/message`, {
      message_id: messageId,
      session_id: sessionId,
      bot_id: botId,
      comment: comment || undefined,
      expected_response: expectedResponse || undefined,
      ...reporterMetadata,
    });

    return {
      ...response,
      success: true,
    };
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
}
